import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  async toggle() {
    const input = this.element.querySelector("input[type='checkbox']")
    const enabled = input.checked

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ enabled })
      })

      if (!response.ok) throw new Error("Failed to toggle analysis share")

      // Show/hide the Copy URL button immediately
      const copyBtn = this.element.nextElementSibling
      if (copyBtn) {
        copyBtn.classList.toggle("hidden", !enabled)
      }
    } catch (error) {
      console.error("Error toggling analysis share:", error)
      input.checked = !enabled
    }
  }
}
